<div class="confirm-container">
  <h1
    mat-dialog-title
    class="dialog-title"
  >
    <mat-icon class="warning-icon">warning</mat-icon>
    {{ 'COMPLETE_ALERT' | translate }}
  </h1>

  <mat-dialog-content>
    <p>{{ 'CONFIRM_COMPLETE_ALERT' | translate }}</p>
    @if (data.header) {
    <p class="alert-identity">
      <strong>{{ data.header }}@if (data.productId) { ({{ data.productId }})}</strong>
    </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <!-- Cancel takes the initial focus so a stray keypress cannot finish the alert -->
    <button
      mat-stroked-button
      class="cancel-btn"
      cdkFocusInitial
      data-testid="complete-alert-cancel"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
      {{ 'CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      class="confirm-btn"
      data-testid="complete-alert-confirm"
      (click)="confirm()"
    >
      <mat-icon>check</mat-icon>
      {{ 'COMPLETE_ALERT' | translate }}
    </button>
  </mat-dialog-actions>
</div>
